import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SESSION_STORAGE_KEY_MAP, ssoAuthorizeUrl } from "../utils/constant";
import expiredIcon from "../images/expired.svg";
import { AppContext } from "../store";
import "../styles/ssoAuthorize.scss";

type ErrorState = {
  code: string;
  title: string;
  message: string;
};

const errorContentMap: { [key: string]: ErrorState } = {
  ticket_missing: {
    code: "ticket_missing",
    title: "未获取到授权信息",
    message: "当前页面缺少必要的授权参数，请返回来源页面重新进入活动。",
  },
  ticket_expired: {
    code: "ticket_expired",
    title: "授权链接已失效",
    message: "该授权链接已过期或已被使用，请返回来源系统重新打开活动页面。",
  },
  ticket_invalid: {
    code: "ticket_invalid",
    title: "授权链接已失效",
    message: "该授权链接已过期或已被使用，请返回来源系统重新打开活动页面。",
  },
  ticket_redeemed: {
    code: "ticket_redeemed",
    title: "授权链接已失效",
    message: "该授权链接已过期或已被使用，请返回来源系统重新打开活动页面。",
  },
};

const SsoAuthorize = () => {
  const [error, setError] = useState<ErrorState | null>(null);
  const navigate = useNavigate();
  const { setLoginState } = useContext(AppContext);

  useEffect(() => {
    const ticket = new URLSearchParams(window.location.search).get("ticket");
    if (!ticket) {
      setError(errorContentMap.ticket_missing);
      return;
    }
    fetch(`${ssoAuthorizeUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ticket }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status !== "success" || !res.data?.token) {
          setError(
            errorContentMap[res.status] || {
              code: res.status || "sso_failed",
              title: "授权失败",
              message: res.message || "当前无法完成授权，请稍后重试。",
            }
          );
          return;
        }
        const token = res.data.token;
        sessionStorage.setItem(SESSION_STORAGE_KEY_MAP.AUTH_TOKEN, token);
        const returnUrl = res.data.returnUrl || "/";
        if (returnUrl.startsWith("http://") || returnUrl.startsWith("https://")) {
          window.location.replace(returnUrl);
          return;
        }

        window.location.replace(`${window.location.origin}${returnUrl}`);
      })
      .catch((err) => {
        setError({
          code: "sso_failed",
          title: "授权失败",
          message: err?.message || "当前无法完成授权，请稍后重试。",
        });
      });
  }, [navigate]);

  if (error) {
    return (
      <div className="ssoAuthorizePage">
        <div className="ssoAuthorizeCard">
          <img className="ssoAuthorizeIcon" src={expiredIcon} alt="sso error" />
          <div className="ssoAuthorizeTitle">{error.title}</div>
          <div className="ssoAuthorizeMessage">{error.message}</div>
          <div className="ssoAuthorizeHint">
            错误码：<span>{error.code}</span>
          </div>
          <div className="ssoAuthorizeActions">
            <button
              type="button"
              className="ssoAuthorizeBtn primary"
              onClick={() => window.close()}
            >
              关闭页面
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ssoAuthorizePage">
      <div className="ssoAuthorizeCard loading">
        <div className="ssoAuthorizeLoader" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className="ssoAuthorizeTitle loadingText">
          正在完成授权
          <span className="ssoAuthorizeDots">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </div>
        <div className="ssoAuthorizeMessage">
          正在为您同步登录状态，即将跳转到活动页面。
        </div>
      </div>
    </div>
  );
};

export default SsoAuthorize;
